import Favourite from './Favourite';

const FavouriteBar = Favourite;
export default FavouriteBar;
